import clsx from 'clsx';
import './styles.css';

export default function KitoProgressBar({ current, final, color, showData = true, text }) {
  return (
    <div className="kito-progress-bar">
      {showData && (
        <div className="kito-progress-bar__data">
          <span>{text || ''}</span>
          <span>{(current * 100) / final} %</span>
        </div>
      )}
      <div className="kito-progress-bar__bar">
        <div
          style={{ width: `${(current * 100) / final}%` }}
          className={clsx('kito-progress-bar__current-bar', color && `kito-progress-bar__current-bar__${color}`)}
        />
      </div>
    </div>
  );
}
